import { useNavigation, useRoute } from "@react-navigation/native";
import React, { useEffect } from "react";
import { View } from "react-native";
import { StatusBar } from "@common/systemBars/StatusBar";
import { theme } from "@common/theme/theme";
import TextM from "../../../common/components/text/TextM";
import FilledButtonM from "../../../common/components/button/FilledButtonM";
import { capitalize, formatMinutes } from "@data/utility/Utils";
import moment from "moment";
import { connect } from "react-redux";
import { apiIdle, apiRequest } from "@data/redux/actions/api";
import { ChampionImageM } from "../../../student/champions/ChampionImageM";
import TitleM from "@common/components/text/TitleM";
import { ActivityIndicator } from "react-native-paper";
import { authService } from "@data/services/authService";
import { substitutionProposalsService } from "@data/services/substitutionProposalsService";
import { DialogM } from "@common/components/alert/dialog/Dialog";
import { useApiStatus } from "@common/hooks/useApiStatus";

function SubstitutionProposalScreen(props) {
    const navigation = useNavigation();
    const route = useRoute();

    const proposalId = route?.params?.substitution_proposal_id ?? null;
    const hash = route?.params?.hash ?? null;

    const proposal = hash
        ? props.substitutionProposalByHash
        : props.user?.substitution_proposals?.find(p => p.id === parseInt(proposalId));

    const substitution = proposal?.substitution;
    const liveSession = substitution?.live_session;

    const isPending = proposal?.status === "pending";

    const title = isPending ? "Nouvelle proposition de remplacement" : "Dommage !";
    const description =
        isPending
            ? (capitalize(
                moment(substitution?.date)?.format("dddd" + " DD MMMM [à] HH:mm") +
                " - " +
                formatMinutes(liveSession?.duration)
            ) +
                "\n" +
                liveSession?.school_subjects_classes_string)
            : "Un tuteur a déjà accepté ce remplacement. Une autre fois peut-être !";

    useEffect(() => {
        if (hash) {
            // Load proposal using hash
            props.apiRequest(
                substitutionProposalsService.getSubstitutionProposalByHash,
                {},
                {},
                { hash }
            );
        } else {
            // Load proposal using ID and user data
            props.apiRequest(authService.getUser);
        }
    }, [proposalId, hash]);

    useApiStatus(
        hash ? substitutionProposalsService.updateSubstitutionProposalStatusByHash : substitutionProposalsService.updateSubstitutionProposalStatus,
        null,
        true,
        (successData) => {
            const status = successData?.status;
            const message = status === "accepted"
                ? "La proposition a été acceptée !"
                : "La proposition a été masquée.";

            setTimeout(() => {
                DialogM.show({
                    text1: "Succès",
                    text2: message,
                    buttonText1: "OK",
                    onPress: () => {
                    }
                });
            }, 200);
            navigation.goBack();
            if (!hash) {
                props.apiRequest(authService.getUser);
            }
        }
    );

    const handleStatusUpdate = (status) => {
        if (hash) {
            // Use unguarded endpoint with hash
            props.apiRequest(
                substitutionProposalsService.updateSubstitutionProposalStatusByHash,
                {},
                {
                    hash,
                    status
                }
            );
        } else {
            // Use authenticated endpoint with ID
            props.apiRequest(
                substitutionProposalsService.updateSubstitutionProposalStatus,
                {
                    id: proposalId
                },
                {
                    status
                }
            );
        }
    };

    const isLoading = props.getUserRequest || props.getSubstitutionProposalByHashRequest;
    const isUpdating = props.updateSubstitutionProposalStatusRequest || props.updateSubstitutionProposalStatusByHashRequest;

    return (
        <View style={{
            alignItems: 'center',
            flex: 1,
            padding: 20
        }}>
            {(isLoading || isUpdating) ? <ActivityIndicator
                color={theme.colors.primary}
                style={{
                    marginTop: 10
                }}
            /> : proposal ? <>
                <ChampionImageM name="zoe"
                    variant={isPending ? "main" : "unhappy"}
                    width={140} />
                <TitleM fontWeight="ExtraBold"
                    style={{ textAlign: "center", marginTop: 10, color: theme.colors.primary }}
                    wrap>{title}</TitleM>
                <TextM fontWeight="Medium" style={{ textAlign: "center" }} wrap>{description}</TextM>
                {isPending && <>
                    <FilledButtonM onPress={() => {
                        DialogM.show({
                            text1: "Es-tu sûr.e d'accepter ce remplacement ?",
                            text2: description,
                            buttonText1: "Je confirme que j'accepte",
                            onPress: () => {
                                handleStatusUpdate("accepted");
                            },
                            buttonText2: "Annuler"
                        });
                    }}
                        disabled={isUpdating}
                        color={theme.colors.primary}
                        style={{ marginTop: 20 }}
                        label={"Accepter la proposition"}
                    />
                    <FilledButtonM
                        onPress={() => {
                            handleStatusUpdate("rejected");
                        }}
                        disabled={isUpdating}
                        color={theme.colors.error}
                        label={"Masquer la proposition"}
                    />
                </>}
            </> : <TextM fontWeight="Medium" style={{ textAlign: "center" }} wrap>Cette demande n'est plus d'actualité</TextM>}
            <FilledButtonM
                onPress={() => {
                    navigation.goBack();
                }}
                mode={"text"}
                label={"Retour"}
            />
            <StatusBar style="dark" backgroundColor={theme.colors.white} translucent={false} />
        </View>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        getUserRequest: state.api.getUser?.request,
        getSubstitutionProposalByHashRequest: state.api.getSubstitutionProposalByHash?.request,
        updateSubstitutionProposalStatusRequest: state.api.updateSubstitutionProposalStatus?.request,
        updateSubstitutionProposalStatusByHashRequest: state.api.updateSubstitutionProposalStatusByHash?.request,
        substitutionProposalByHash: state.data.formData?.substitutionProposalByHash
    };
};

const mapDispatchToProps = {
    apiRequest,
    apiIdle
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SubstitutionProposalScreen);
